import { createContext, useContext } from 'react';
import { Settings } from '@/types';
const SettingsContext = createContext<Settings | null>(null);

export const useSettings = () => {
  const settings = useContext(SettingsContext);

  if (!settings) {
    throw new Error('SettingsProvider missing');
  }

  return settings;
};

export default SettingsContext;